import { Controller } from "@hotwired/stimulus"
import conversation_controller from "./conversation_controller";

export default class extends Controller {
  static targets = ["complianceMode", "emailCoordinationMode", "predefinedAnswersMode", "channelId", "support", "responseId", "responseIdPreDef", "emailText", "responseText", "responseDescription", "emailDescription", "responseIdPreDefDescription", "channelDescription", "actionDescription", "actionLabel"]
  static values = {
    variants: String
  }

  connect() {
    this.variants = JSON.parse(this.variantsValue);
  }

  complianceModeTargetConnected(target) {
    this.previousComplianceMode = target.checked;
    target.addEventListener("change", this.toggle.bind(this));
  }

  emailCoordinationModeTargetConnected(target) {
    target.addEventListener("change", this.toggle.bind(this));
  }

  predefinedAnswersModeTargetConnected(target) {
    this.previousPredefinedAnswersMode = target.checked;
    target.addEventListener("change", this.toggle.bind(this));
  }

  supportTargetConnected(target) {
    target.addEventListener("change", this.toggle.bind(this));
  }

  toggle() {
    /* we have to ensure that this cannot happen */
    if (this.complianceModeTarget.checked && this.predefinedAnswersModeTarget.checked) {
      /* Compliance Mode was enabled, so we disable predefined answers mode or
       * the other way around.
       */
      if (!this.previousComplianceMode) {
        this.predefinedAnswersModeTarget.checked = false;
      } else {
        this.complianceModeTarget.checked = false;
      }
    }

    const complianceMode = this.complianceModeTarget.checked;
    const emailCoordinationMode = this.emailCoordinationModeTarget.checked;
    const predefinedAnswersMode = this.predefinedAnswersModeTarget.checked;
    const support = this.supportTarget.checked;

    /* still unsupported case and therefore just an intermittend state */
    if (complianceMode && emailCoordinationMode) {
      return;
    }

    this.previousComplianceMode = complianceMode;
    this.previousPredefinedAnswersMode = predefinedAnswersMode;

    const name = this.variants[complianceMode][emailCoordinationMode][predefinedAnswersMode][support].name;
    const fields = JSON.parse(this.variants[complianceMode][emailCoordinationMode][predefinedAnswersMode][support].fields);

    if (complianceMode) {
      this.responseIdTarget.classList.remove("d-none");
      this.responseTextTarget.classList.add("d-none");
    } else {
      this.responseIdTarget.classList.add("d-none");
      this.responseTextTarget.classList.remove("d-none");
    }

    if (emailCoordinationMode) {
      this.emailTextTarget.classList.remove("d-none");
      this.channelIdTarget.classList.remove("d-none");
      this.channelDescriptionTarget.innerText = window.I18n.structured_output.channel[name];
      this.emailDescriptionTarget.innerText = window.I18n.structured_output.email[name];
    } else {
      this.channelIdTarget.classList.add("d-none");
      this.emailTextTarget.classList.add("d-none");
    }

    if (predefinedAnswersMode) {
      this.responseIdPreDefTarget.classList.remove("d-none");
      this.responseIdPreDefDescriptionTarget.innerText = window.I18n.structured_output.predefined_answer[name];
    } else {
      this.responseIdPreDefTarget.classList.add("d-none");
    }

    this.responseDescriptionTarget.innerText = window.I18n.structured_output.response[name];

    this.actionLabelTarget.innerText = " (action - enum: [:" + fields.action.type.values.join(", :") + "])";
    this.actionDescriptionTarget.innerText = window.I18n.structured_output.action[name];
  }
}
